<template>
	<div :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type">
		<div class="number-input">
			<div class="prepend">{{ context.attributes.currency || '$' }}</div>

			<currency-input
				v-model="formatted"
				v-bind="context.attributes"
				:options="{ currency: 'USD', currencyDisplay: 'hidden', precision: 2 }"
				@change="value = $event"
			/>
		</div>
	</div>
</template>

<script>
import CurrencyInput from './CurrencyInput'

export default {
	name: 'InputPrice',
	components: { CurrencyInput },
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {}
	},
	computed: {
		formatted: {
			get: function() {
				return this.context.model ? parseFloat(this.context.model) : 0
			},
			set: function(newValue) {
				this.context.model = newValue
			},
		},
	},
}
</script>

<style scoped>
.number-input {
	display: flex;
	border: solid 1px #cecece;
	border-radius: 0.3em !important;
	position: relative;
}
.number-input .prepend {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f3f3f3;
	padding: 0px 8px;
	border-right: 0px;
}
.number-input input {
	text-align: right;
	padding: 0.75em 0.25em;
	border: none !important;
}
.number-input:after {
	content: 'IVA/incl';
	position: absolute;
	color: #9e9e9e;
	font-size: 10px;
	right: 0px;
	bottom: -14px;
	/* display: flex;
	align-items: flex-end;
	padding: 0.75em 0.25em 0.75em 0; */
}
</style>
